import React from 'react';
import {documentTypes} from '../../../../../../../util/uiconstants';
import ProfileBanner from './ProfileBanner';
import IndependenceBanner from './IndependenceBanner';
import IndependenceTemplateBanner from './IndependenceTemplateBanner';
import MultiEntityIndividualProfileBanner from './MultiEntityIndividualProfileBanner';

const independenceBanner = (props) => {
	return <IndependenceBanner {...props} />;
};

const independenceTemplateBanner = (props) => {
	return <IndependenceTemplateBanner {...props} />;
};

const profileBanner = (props) => {
	return <ProfileBanner {...props} />;
};
const multiEntityIndividualProfileBanner = (props) => {
	return <MultiEntityIndividualProfileBanner {...props} />;
};

const bannerConfig = {
	[documentTypes.INDEPENDENCEFORMINDIVIDUAL]: {
		render: independenceBanner
	},
	[documentTypes.INDEPENDENCEFORMTEMPLATE]: {
		render: independenceTemplateBanner
	},
	[documentTypes.PROFILEV2]: {
		render: profileBanner
	},
	[documentTypes.MULTIENTITYINDIVIDUALPROFILE]: {
		render: multiEntityIndividualProfileBanner
	}
};

export function getBannerConfig(documentTypeId, bannerProps) {
	const _bannerConfig = bannerConfig[documentTypeId];

	return _bannerConfig?.render(bannerProps);
}
